import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, EyeOff, Mail } from 'lucide-react';
import { logoColor } from '../../ui/media';
import { themeStore } from '../../../stores/theme';
import { useStore } from '@tanstack/react-store';
import { useLogin } from '../../../hooks/useAuth';
import toast from 'react-hot-toast';

// Main App Component
const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const { isDarkMode } = useStore(themeStore)
  const loginMutation = useLogin()
  const navigate = useNavigate()

  const handleLogin = (e) => {
    e.preventDefault()
    if (email == "" || password == "") {
      toast.error("Email and Password are not allowed to empty")
      return
    }
    loginMutation.mutate({ email, password }, {
      onSuccess: (data) => {
        toast.success("Login successful");
        if(data?.data?.data?.user_type == 2) {
          navigate('/events/list');
        } else {
          navigate('/locations/list');
        }
      },
      onError: (error) => {
        const message = error.response?.data?.message || "Login failed"
        toast.error(message)
      }
    })
  };

  const Logo = () => {
    return (
      <div className="flex flex-col items-center">
        <img src={logoColor} className='h-[70px]' />
      </div>
    );
  };

  return (
    <div className={`min-h-screen flex items-center justify-center p-4`}>
      <div className={`w-full max-w-md rounded-lg shadow-lg mt-[70px] overflow-hidden ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
        {/* Logo Header */}
        <div className="bg-blue-100 w-[95%] mx-auto my-3 rounded-lg p-6 flex justify-center">
          <div className="flex flex-col items-center">
            <Logo />
          </div>
        </div>
        <h1 className={`text-2xl poppins-regular font-bold mt-4 text-center ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>Let's Get Started!</h1>
        <p className={`text-sm mt-2 text-center ${isDarkMode ? 'text-white' : 'text-gray-600'}`}>
          Please enter the email address & password<br />to login into your account.
        </p>
        {/* Login Form */}
        <div className="p-6">
          <div className="mb-4">
            <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-white' : 'text-gray-600'}`}>Email</label>
            <div className="relative">
              <input
                placeholder='Enter email address'
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={`w-full p-3 rounded border ${isDarkMode
                  ? 'bg-gray-700 border-gray-600 text-white'
                  : 'bg-white border-gray-300'
                  }`}
              />
              <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                <Mail size={18} className="text-blue-600" />
              </div>
            </div>
          </div>
          <div className="mb-4">
            <div className="flex justify-between">
              <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-white' : 'text-gray-600'}`}>Password</label>
            </div>
            <div className="relative">
              <input
                placeholder='********'
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className={`w-full p-3 rounded border ${isDarkMode
                  ? 'bg-gray-700 border-gray-600 text-white'
                  : 'bg-white border-gray-300'
                  }`}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute inset-y-0 right-0 flex items-center pr-3">
                {showPassword ?
                  <EyeOff size={18} className="text-blue-600" /> :
                  <Eye size={18} className="text-blue-600" />
                }
              </button>
            </div>
            <div className="text-right mt-1">
              <button
                onClick={() => navigate('/forgot-password')}
                type="button"
                className="text-sm text-blue-600 hover:underline">
                Forgot Password?
              </button>
            </div>
          </div>
          <div className='text-center'>
            <button
              onClick={handleLogin}
              disabled={loginMutation.isLoading}
              className="w-[200px] poppins-regular bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-full text-center">
              {loginMutation.isLoading ? "Logging in..." : "Login"}
            </button>
          </div>
        </div>
        {/* Footer Link */}
        <div className={`p-4 text-center ${isDarkMode ? 'bg-gray-700' : 'bg-blue-100'}`}>
          <p className={`${isDarkMode ? 'text-white' : 'text-gray-600'}`}>
            Don't have an account?
            <button
              onClick={() => navigate("/register")}
              className="ml-1 poppins-regular font-bold text-blue-600 hover:underline">
              Register
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};
export default Login